export const roundTo2Digits = (number) => {
  if (number === undefined || number === null) {
    return number;
  }
  const floatNumber = parseFloat(number);
  if (isNaN(floatNumber)) {
    return number;
  }
  const result = Math.round(floatNumber * 100) / 100;
  return result.toFixed(2);
};

export const toPlus = (amount) => {
  if (amount < 500) {
    return amount;
  } else {
    return parseInt(amount / 100) * 100 + '+';
  }
};

export const toPercentage = (number) => {
  const parsed = parseFloat(number);
  if (isNaN(parsed)) {
    return;
  }
  if (parsed > 1) {
    return number;
  } else {
    return parsed * 100;
  }
};

export const toPrice = (price) => {
  if (price === undefined || price === null) {
    return null;
  }
  const floatPrice = parseFloat(price);
  return `$${floatPrice.toFixed(2)}`;
};

export const kmToMile = (km) => km * 0.621371;

export const toSupportedCountryAbbreviation = (country) => {
  switch (country.toLowerCase()) {
    case 'canada': {
      return 'CA';
    }
    default: {
      return 'US';
    }
  }
};
